import request from "@/utils/request";

export function signIn(params = {}) {
  return request({
    method: "post",
    url: "/users/email/login/",
    data: params
  });
}

export function userRegister(params = {}) {
  return request({
    method: "post",
    url: "/users/register/",
    data: params
  });
}

export function userVerifyCode(params = {}) {
  return request({
    method: "post",
    url: "/users/verifycode/",
    data: params
  });
}

export function userForgetPassword(params = {}) {
  return request({
    method: "post",
    url: "/users/password/forget/",
    data: params
  });
}

export function signOut() {
  return new Promise(resolve => {
    resolve(true);
  });
}

export function refreshToken(params = {}) {
  return request({
    method: "post",
    url: "/users/token/refresh/",
    data: params
  });
}

export function getUserInfo(params = {}) {
  return request({
    method: "get",
    url: `/users/me/`,
    data: params
  });
}

export function sendUserInfo(params = {}) {
  return request({
    method: "post",
    url: "/users/me/",
    data: params
  });
}

export function getReserveInfo(params = {}) {
  return request({
    method: "get",
    url: `/users/reserve/`,
    data: params
  });
}

export function submitReserveInfo(params = {}) {
  return request({
    method: "post",
    url: `/users/reserve/`,
    data: params
  });
}

export function getInfoByID(params = {},id) {
  return request({
    method: "get",
    url: `/users/info/${id}`,
    data: params
  });
}

export function timezoneConvert(params = {}) {
  return request({
    method: "post",
    url: `/users/timezone/convert/`,
    data: params
  });
}

export function getIndividualList(params = {}) {
  return request({
    method: "get",
    url: `/users/engagement/individual/list/`,
    data: params
  });
}

export function putIndividualList(params = {}) {
  return request({
    method: "put",
    url: `/users/engagement/individual/list/`,
    data: params
  });
}

export function getReservationHistory(params = {}) {
  return request({
    method: "get",
    url: `/users/reservation/history/`,
    data: params
  });
}